import buildChartTheme, { ThemeConfig } from '@visx/xychart/lib/theme/buildChartTheme';

export const createTheme = (overrides: Partial<ThemeConfig>) => {
    return buildChartTheme({
        backgroundColor: 'var(--color-surface)',
        tickLength: 0,
        gridColor: 'var(--color-surface-interact)',
        gridColorDark: 'var(--color-surface-interact)',
        xAxisLineStyles: {
            stroke: 'none',
        },
        yAxisLineStyles: {
            stroke: 'none',
        },
        xTickLineStyles: {
            strokeWidth: 0.5,
            strokeOpacity: 0.5,
        },
        yTickLineStyles: {
            strokeWidth: 0.5,
            strokeOpacity: 0.5,
        },
        gridStyles: {
            strokeWidth: 0.25,
        },
        ...overrides,
    } as ThemeConfig);
};
